/*
 * File: index.vue.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:57:30
 * Modified By: Val Liu
 * -----
 */

import { Component, Vue } from "vue-property-decorator";
import { Theme } from "@/../core/theme";

@Component
export default class MainApp extends Vue {
    private step() {
        //this.steps[this.$theme.name];
        return this.steps.indexOf(this.$theme.name);
    }
    private get steps() {
        let themeList = Theme.list();
        return Object.keys(themeList).reduce<any[]>((final, value) => {
            let themeUnit = themeList[value];
            final.push(themeUnit.element.name);
            return final;
        }, []);
    }
}
